<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("city", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("city_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Cities')"
          variant="default"
          to="add-city"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex">
        <div>
          <b-form-input
            v-debounce:300="getCitiesList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
        <div class="ml-3" style="width: 250px;">
          <div class="dropdown-curve-container">
            <label
              :class="
                selectedCountry && selectedCountry.country_id ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("country", 1) }}</label
            >
            <multiselect
              :options="countryList"
              v-model="selectedCountry"
              :searchable="true"
              label="country_name"
              track-by="country_id"
              placeholder="Select Country"
              @input="onChangeCountry($event)"
              :allowEmpty="false"
              :showLabels="false"
              :clearable="true"
            ></multiselect>
          </div>
        </div>
        <div class="ml-3" style="width: 250px;">
          <div class="dropdown-curve-container">
            <label
              :class="selectedState && selectedState.state_id ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("state", 1) }}</label
            >
            <multiselect
              :options="stateList"
              v-model="selectedState"
              :searchable="true"
              label="state_name"
              track-by="state_id"
              placeholder="Select State"
              @input="onChangeState($event)"
              :allowEmpty="false"
              :showLabels="false"
              :clearable="true"
            ></multiselect>
          </div>
        </div>
        <button @click="onClear" class="btn-blue ml-3">Clear</button>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Cities.length > 0"
        v-for="(item, key) in Cities"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.city_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Cities')"
                  @click="goToRoute('/master/edit-city', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/master/view-city', item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="item.city_is_active ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Cities.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 400px;">
            <img
              v-if="this.columnName != 'city_name'"
              @click="onSortValue('city_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('city_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('city_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("city", 1) }}
          </th>
          <th style="width: 200px; text-align: center">
            <img
              v-if="this.columnName != 'city_code'"
              @click="onSortValue('city_code', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('city_code', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('city_code', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("city", 1) }} {{ $tc("Code", 1) }}
          </th>
          <th>{{ $tc("state", 1) }}</th>
          <th>{{ $tc("country", 1) }}</th>

        </tr>
      </thead>
      <tbody v-if="Cities.length > 0">
        <tr v-for="(item, key) in Cities" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.city_is_active ? 'active' : 'inactive'"
              />

              <div
                v-if="$can('update', 'Cities')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/master/edit-city', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>

              <div
                class="clickable-icon ml-2"
                @click="goToRoute('/master/view-city', item)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td>{{ $tc(item.city_name, 1) }}</td>
          <td class="text-center">
            {{ item.city_code ? item.city_code : "-" }}
          </td>
          <td>{{item.state_name?item.state_name:"-"}}</td>
          <td>{{item.country_name?item.country_name:"-"}}</td>
        </tr>
      </tbody>

      <tbody v-if="Cities.length === 0">
        <tr>
          <td colspan="3">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="Cities.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Cities from "@/helper/formJSONMaster/Cities";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Cities.Methods,
      Cities: [],
      viewingnumbers: [],
      customErrors: {
        message: ""
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "city_name",
      countryList: [],
      countryListCopy: [],
      stateList: [],
      stateListCopy: [],
      selectedCountry: null,
      selectedCountry_id: null,
      selectedState: null,
      selectedState_id: null
    };
  },
  beforeMount() {
    this.getCitiesList();
    this.getCountryList();
    this.getStateList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    }
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCitiesList();
      } else {
        this.currentPage = event;
        this.getCitiesList();
      }
    },
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { city_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: city_id
        }
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      if (this.columnName === columnName) {
        this.isAscending = !this.isAscending;
      } else {
        this.isAscending = orderby === "asc" ? true : false;
      }
      this.isSort = true;
      // this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCitiesList();
    },
    getCitiesList: function() {
      this.Cities = [];
      // let body = this.getRequestBody("GET", undefined, this.Methods);
      // body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}`;
      // console.log("body :", body);
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        columnName: this.columnName
      };
      if (this.selectedCountry_id) {
        console.log("selectedCountry =>", this.selectedCountry);
        payload.country_id = this.selectedCountry_id;
      }
      if (this.selectedState_id) {
        console.log("selectedState =>", this.selectedState);
        payload.state_id = this.selectedState_id;
      }
      MasterService.getCityDataWithCountryAndState(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Cities = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCountryList: function(value, index) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries"
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
            let array = this.countryList.filter(x => x.country_id === value);
            if (value && index && array.length > 0) {
              this.States[index].dropdownSelected = array[0].country_name;
            }
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },

    // getStateList: function(uniqueId, countryId) {
    //   this.stateList = [];
      
    //     let body = this.getRequestBody("GET", undefined, {
    //       GET: "/admin/tablelist/",
    //       tableName: "ms_states",
    //       // params: { id: "country_id-" + countryId }
    //     });
    //     MasterService.GlobalRequest(body)
    //       .then(response => {
    //         const { data } = response;
    //         if (data.status && data.Records.length > 0) {
    //           this.stateList = data.Records;
    //           this.stateListCopy = data.Records;
    //           // if (uniqueId) {
    //           //   this.setNestedDropdownFields(
    //           //     "state_id",
    //           //     uniqueId,
    //           //     data.Records
    //           //   );
    //           // } else {
    //           //   // this.setStateHandler(countryId);
    //           //   this.setDropdownHandler(null, "state", data.Records, ["city"]);
    //           // }
    //         } else {
    //           // Show Errors
    //           console.log("show error :", data.message);
    //           // this.setStateHandler(null);
    //         }
    //       })
    //       .catch(error => {
    //         // Show Catch Error
    //         console.log("show error :", error);
    //       });
      
    // },
    getStateList: function () {
  
      let payload={
      }
   // Check if selectedCountry is valid and has the country_id property
  // if (this.selectedCountry && this.selectedCountry.hasOwnProperty("country_id")) {
    if (this.selectedCountry_id) {

    console.log("selectedCountry =>", this.selectedCountry);
    payload.country_id = this.selectedCountry_id;
  } else {
    console.warn("selectedCountry is undefined or does not have country_id");
  }
      MasterService.getStateDataWithCountry(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.stateList = data.Records;
          
            } 
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onChangeCountry: function(item) {
      console.log("item->", item.country_id);
      this.selectedCountry = item;
      this.selectedCountry_id = item.country_id;
      this.getCitiesList();
      this.getStateList();
    },
    onChangeState: function(item) {
      console.log("item->", item.country_id);
      this.selectedState = item;
      this.selectedState_id = item.state_id;
      this.getCitiesList();
    },

    onClear: function () {
  this.searchValue = "";
  this.selectedCountry = null;
  this.selectedCountry_id = null;

  this.selectedState = null;
  this.selectedState_id = null;

  // Force reactivity (if needed)
  this.$nextTick(() => {
    this.getCitiesList();
  });
},

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CityComponents/city.vue